import React from 'react';

/* Íconos de línea (estilo Lucide: trazo de 2 px sobre 24×24) para el marco del panel.
   Van en SVG dentro de React, sin depender de Font Awesome (que nunca se cargaba). */
const TRAZOS = {
  inicio: <><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /><path d="M10 21v-6h4v6" /></>,
  factura: <><path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2Z" /><path d="M9 8h6M9 12h6M9 16h3" /></>,
  monitor: <><rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" /></>,
  lista: <><rect x="5" y="4" width="14" height="18" rx="2" /><path d="M9 2h6v4H9z" /><path d="M9 11h6M9 15h6" /></>,
  ajustes: <><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M2 14h4M10 8h4M18 16h4" /></>,
  escudo: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /></>,
  herramientas: <><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9Z" /></>,
  laboratorio: <><path d="M9 3h6" /><path d="M10 3v6L4.6 18.4A1.8 1.8 0 0 0 6.2 21h11.6a1.8 1.8 0 0 0 1.6-2.6L14 9V3" /><path d="M7.5 15h9" /></>,
  grafico: <><path d="M3 3v18h18" /><path d="M8 17v-6M13 17V7M18 17v-3" /></>,
  usuarios: <><circle cx="9" cy="8" r="4" /><path d="M2 21a7 7 0 0 1 14 0" /><path d="M16 4a4 4 0 0 1 0 8M22 21a7 7 0 0 0-4-6.3" /></>,
  carpeta: <><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" /></>,
  buscar: <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>,
  flecha: <><path d="m9 18 6-6-6-6" /></>,
  estrella: <><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9Z" /></>,
  reloj: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  teclado: <><rect x="2" y="6" width="20" height="12" rx="2" /><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10" /></>,
  salir: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></>,
  menu: <><path d="M3 6h18M3 12h18M3 18h18" /></>,
  contraer: <><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 3v18" /><path d="m16 15-3-3 3-3" /></>,
  expandir: <><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 3v18" /><path d="m14 9 3 3-3 3" /></>,
  pantalla: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18" /></>,
  accion: <><path d="M13 2 3 14h9l-1 8 10-12h-9Z" /></>,
  usuario: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  calendario: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></>,
  llave: <><circle cx="7.5" cy="15.5" r="4.5" /><path d="m10.7 12.3 9.3-9.3M16 7l3 3M18.5 4.5l2 2" /></>,
  documento: <><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z" /><path d="M14 3v6h6M8 13h8M8 17h6" /></>,
  imprimir: <><path d="M6 9V3h12v6" /><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><path d="M6 14h12v7H6z" /></>,
  check: <><path d="M20 6 9 17l-5-5" /></>,
  etiqueta: <><path d="M3 3h8l10 10-8 8L3 11Z" /><circle cx="7.5" cy="7.5" r="1.5" /></>,
  empresa: <><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 21v-4h6v4" /><path d="M8 7h2M14 7h2M8 11h2M14 11h2" /></>,
  cerrar: <><path d="M18 6 6 18M6 6l12 12" /></>,
  enter: <><path d="M9 10 4 15l5 5" /><path d="M20 4v7a4 4 0 0 1-4 4H4" /></>,
  mapa: <><path d="M12 22s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12Z" /><circle cx="12" cy="10" r="2.5" /></>,
  pantallaCompleta: <><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3" /></>,
};

/* Ícono para cada carpeta del menú (el nombre viene de la tabla «opciones») */
const POR_CARPETA = [
  [/factur|cartera|caja|pago|rips/, 'factura'],
  [/maquin|interfa|equipo/, 'monitor'],
  [/orden|ingreso|atencion/, 'lista'],
  [/resultado|laborat|examen|analisis/, 'laboratorio'],
  [/parametr|configur|tabla/, 'ajustes'],
  [/seguridad|usuario|rol/, 'escudo'],
  [/utilidad|herramienta/, 'herramientas'],
  [/reporte|informe|estadist|indicador|bi$/, 'grafico'],
  [/paciente|medico/, 'usuarios'],
];

export const sinTildes = (t = '') => String(t).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

/* Nombre de carpeta para mostrar: la tabla «opciones» los guarda sin tildes («Facturacion», «PARAMETROS») */
const TILDES = {
  facturacion: 'Facturación', parametros: 'Parámetros', maquinas: 'Máquinas', configuracion: 'Configuración',
  administracion: 'Administración', estadisticas: 'Estadísticas', medicos: 'Médicos', analisis: 'Análisis',
  atencion: 'Atención', informacion: 'Información', recepcion: 'Recepción', gestion: 'Gestión', auditoria: 'Auditoría',
};
export const nombreCarpeta = (nombre = '') => String(nombre).trim().split(/\s+/).map((p, i) => {
  const clave = sinTildes(p);
  if (TILDES[clave]) return i === 0 ? TILDES[clave] : TILDES[clave].toLowerCase();
  const min = p.toLowerCase();
  return i === 0 ? min.charAt(0).toUpperCase() + min.slice(1) : min;
}).join(' ');

export const iconoCarpeta = (nombre) => {
  const n = sinTildes(nombre);
  const hallado = POR_CARPETA.find(([re]) => re.test(n));
  return hallado ? hallado[1] : 'carpeta';
};

export default function Icono({ nombre, tam = 18, grosor = 2, className, style, titulo }) {
  return (
    <svg
      className={className}
      style={style}
      width={tam}
      height={tam}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={grosor}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={titulo ? undefined : true}
      role={titulo ? 'img' : undefined}
      focusable="false"
    >
      {titulo && <title>{titulo}</title>}
      {TRAZOS[nombre] || TRAZOS.carpeta}
    </svg>
  );
}
